<svg id='printSectionId' style='padding-left:7%; padding-top:4%;' viewBox='0 0 1010 960'></svg>"